// extracted by mini-css-extract-plugin
export default {"melodyVideo":"XO-z","isFullWidth":"YO-z","landingPageVideo":"ZO-z","play":"_O-z","iframeVideo":"aP-z","playHidden":"bP-z","fullwidth":"cP-z"};